var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-login"},[(!_vm.hasLogin)?_c('a-spin',{staticClass:"login-status-spin"}):_vm._e(),(!_vm.hasBinding)?_c('bind-form',{attrs:{"action":"bind","loginType":"thirdParty","type":"mobile","event":1,"codeToken":_vm.codeToken}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }